/* app/js/src/components/common/_dropdown/dropdown-item.component.scss */
.cursor-pointer {
  cursor: pointer;
}
li {
  cursor: pointer;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
li i {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  max-width: 10px;
  width: 10px;
  height: 12px;
  line-height: 12px;
  margin-right: 9px;
  margin-left: 12px;
}
li i svg {
  max-width: 10px;
  width: 10px;
  height: 12px;
}
li i svg path {
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  -ms-transform: translateX(-10px);
  -webkit-transform: translateX(-10px);
  transform: translateX(-10px);
  opacity: 0;
  fill: #232f3a;
}
li i.multiple {
  position: relative;
}
li i.multiple::before {
  content: " ";
  border: 1px solid #e1e6eb;
  height: 12px;
  width: 12px;
  position: absolute;
  top: -2px;
  left: -2px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
li div {
  -webkit-flex: 12 0 0;
  -ms-flex: 12 0 0;
  flex: 12 0 0;
  color: #7d8fa1;
}
li .defaultOptions {
  position: absolute;
  margin-right: 13px;
  right: 0;
}
li .defaultOptions .default {
  color: #7d8fa1;
}
li .defaultOptions .set-default {
  text-decoration: underline;
  opacity: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
li .align-left {
  text-align: left;
}
li:hover {
  background-color: #eef2f6;
}
li:hover div {
  color: #232f3a;
}
li:hover .defaultOptions .set-default {
  opacity: 1;
}
li:hover i svg path {
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
  opacity: 0.5;
}
li.selected i svg path {
  -ms-transform: translateX(0px);
  -webkit-transform: translateX(0px);
  transform: translateX(0px);
  opacity: 1;
}
li.selected i.multiple::before {
  border-color: #879baf;
}
li.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
li.disabled:hover {
  background-color: transparent;
}
li.disabled:hover div {
  color: #7d8fa1;
}
li.disabled:hover i svg path {
  -ms-transform: translateX(-10px);
  -webkit-transform: translateX(-10px);
  transform: translateX(-10px);
  opacity: 0;
}
.settingIcon {
  cursor: pointer;
  margin-right: 5px;
  margin-top: 3px;
  flex: 0 0 0 !important;
}
.settingIcon ::ng-deep svg {
  width: 13px;
  height: 13px;
}
.settingIcon ::ng-deep svg path {
  fill: #879baf !important;
}
.select-all-option {
  border-bottom: 1px solid #e3e6ea;
}
/*# sourceMappingURL=dropdown-item.component.css.map */
